import retry from "async-retry"
import React, { useContext, useState, useRef } from "react";
// contexts
import RunContext from "./RunContext"
import { UserContext } from "./UserContext/UserContext";
import TxStateContext from "./TxStateContext";
import RuncraftContext from "./RuncraftContext";
// hooks
import useLog from "../hooks/useLog";
// components
import { confirmPopup } from "../components/confirmPopup";
// helpers
import { get_latest_BSVUSD_price } from "../helpers/bsvusd";
import { get_latest_BSVEUR_price } from "../helpers/bsveur";
import { eur_to_sats, sats_to_eur } from "../helpers/convert_bsv_tokens"
import { dictFilterFuncs, getLog, get_afterPercentFee_toAdd, isElectron, isNumber } from "../helpers/helpers";

// to load RUN through webpack externals
// const Run = require("runlib")


const RETRY_REFRESH_AFTER_MS = 2000 // if refreshing failed, will retry after this time
const RUN_ADDRESS_TOKKENR_FEES = "1Fsugn4uQrSJCbeZFiAQbujf1HZbwB6SNW" // DELPHE: tokkenr address

// "1LJSmCYD7ixGrc644CDezyJGHBeZPasEFS" // zhell exodus bsv



// this SwapBotContext is huge, we could split it, ex in 4: userData, userActions, adminData, adminActions ?

// For buying tokens, we use a custom txstate since we have 2 steps to interact with the oracle.
export const txstate_buytokens_oracle = {
	empty: 0,
	sending: 1,
	sending_step2: 2,
	sending_step2_toolong: 3,
	sending_step3: 4,
	sentsuccess: 5,
	sentfail: 6,
}



function arraysAreEqual(a, b) {
	if (a.length !== b.length) return false
	for (let i = a.length; i--;) {
		if (a[i] !== b[i]) return false
	}
	return true
}


const SwapBotContext = React.createContext({})

async function get_spendingTxId(run, target_location, function_id = "") {
	let function_id_2 = function_id + "get_spendingTxId(): for target_location=" + target_location + ": "
	let log = (...args) => { console.log(function_id_2, ...args) }
	if (!target_location || !target_location.includes('_')) {
		throw new Error("Not a location: missing '_', got target_location=" + String(target_location))
	}
	const txid = target_location.split('_')[0]
	const vout = target_location.split('_')[1]

	// const res = await get_spendingTxId_from_blockchair(target_location, function_id)
	const res = await run.blockchain.spends(txid, vout)
	log("res=", res)
	return res
}

/*
// deprecated since blockchair stopped supporting bsv
async function get_spendingTxId_from_blockchair(target_location, function_id = "") {
	// ATTENTION NE PAS METTRE CA DANS CUSTOMBLOCKCHAIN CAR LIMITE A 1000/jour
	// MAIS LE METTRE DANS LE RETRY A PARTIR DU spend2_toolong
	// https://blockchair.com/api/docs#link_M05

	let function_id_2 = function_id + "get_spendingTxId_from_blockchair(): "
	let log = (...args) => { console.log(function_id_2, ...args) }
	if (!target_location || !target_location.includes('_')) {
		throw new Error("Not a location: missing '_', got target_location=" + String(target_location))
	}

	var target_txid = target_location.split('_')[0]
	const blockchair_url = "https://api.blockchair.com/bitcoin-sv/dashboards/transaction/"
	var fetch_url = blockchair_url + target_txid
	var txdata = await fetch(fetch_url)
	txdata = await txdata.json()
	log("blockchair fetch_url=", fetch_url)
	log("txdata=", txdata)

	// get spending_transaction_hash
	var output_i = parseInt(target_location.split('_o')[1])
	var data = txdata?.['data']
	if (!data) return null
	var outputs = data?.[target_txid]?.['outputs']
	if (!outputs) return null
	log("data[target_txid]=", data?.[target_txid])
	log("outputs=", outputs)
	log("Object.keys(outputs)=", Object.keys(outputs))
	log("output_i=", output_i)
	log("outputs[output_i]=", outputs?.[output_i])

	var spending_transaction_hash = outputs?.[output_i]?.['spending_transaction_hash']
	log("spending_transaction_hash = ",
		spending_transaction_hash)

	return spending_transaction_hash
}
*/




export const SwapBotContextProvider = (props) => {
	const function_id = "SwapBotContext(): "
	const classname = function_id
	const log = useLog(function_id)

	const userContext = useContext(UserContext)

	const runcraftContext = useContext(RuncraftContext)
	const Runcraft = runcraftContext.Runcraft
	const TokenBuyRequest_User = Runcraft ? Runcraft.TokenBuyRequest_User : null
	const TokenSellRequest_User = Runcraft ? Runcraft.TokenSellRequest_User : null
	const TokenBuyRequest_Admin = Runcraft ? Runcraft.TokenBuyRequest_Admin : null
	const TokenSellRequest_Admin = Runcraft ? Runcraft.TokenSellRequest_Admin : null
	const BSV_Payment = Runcraft ? Runcraft.BSV_Payment : null

	const runContext = useContext(RunContext)
	const run = runContext.run

	// TODO we might want to split into buy & sell owners ?
	const [swapbotOwner, set_swapbotOwner] = useState(null)
	const [isAdminSwapBotOwner, set_isAdminSwapBotOwner] = useState(false)
	const [hasSet_swapbotAdmin, set_hasSet_swapbotAdmin] = useState(false)
	async function async_set_ownerIsSwapBotAdmin() {
		if (!TokenBuyRequest_Admin || !run) return
		await TokenBuyRequest_Admin.sync()
		const walletOwner = run.owner.address
		set_swapbotOwner(TokenBuyRequest_Admin.owner)
		set_isAdminSwapBotOwner(TokenBuyRequest_Admin.owner === walletOwner)
		set_hasSet_swapbotAdmin(true)
	}
	if (run && TokenBuyRequest_Admin && !hasSet_swapbotAdmin) {
		async_set_ownerIsSwapBotAdmin()
	}

	const inventory_synced_atLeastOnce = runContext.get_syncedAtLeastOnce()

	const tokenID = userContext.get_selected_coin_props().tokenid
	const balance_token = userContext.tokens_balance[tokenID]
	const token_balance_has_loaded = (balance_token != null)

	log("pre:",
		"\n token_balance_has_loaded=", token_balance_has_loaded,
		"\n balance_token=", balance_token,
		"\n userContext.tokens_balance[tokenID]=", userContext.tokens_balance[tokenID],
		"\n inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce,
		"\n hasSet_swapbotAdmin=", hasSet_swapbotAdmin
	)

	//
	// public state we want to expose to consumers
	//

	// if true then the rest will never load, and we should display an error message
	const [isWrongTokenType_buy, set_isWrongTokenType_buy] = useState(false)
	const [isWrongTokenType_sell, set_isWrongTokenType_sell] = useState(false)

	const [base_price, set_base_price] = useState(null)
	const [secondary_price, set_secondary_price] = useState(null)
	const [nb_available_tokens, set_nb_available_tokens] = useState(null)

	const [history_nb_available_tokens, set_history_nb_available_tokens] = useState(null)

	const [user_buy_requests, set_user_buy_requests] = useState(null)
	const [user_sell_requests, set_user_sell_requests] = useState(null)

	const [buy_oracle_priceUSD, set_buy_oracle_priceUSD] = useState(null)
	const [sell_oracle_priceUSD, set_sell_oracle_priceUSD] = useState(null)

	const [admin_buy_requests, set_admin_buy_requests] = useState(null)
	const [admin_sell_requests, set_admin_sell_requests] = useState(null)

	const [refreshCounter, set_refreshCounter] = useState(0)

	const [isloading, set_isloading] = useState(true)
	const [init_state_finished, set_init_state_finished] = useState(false)

	const [popup_lock, set_popup_lock] = useState(false) // ensure only 1 popup at a time

	// LOGGING ONLY WHEN A VAR TO LOG CHANGED to not pollute logs
	const curr_log_vars_array = [isloading, init_state_finished, base_price,
		secondary_price, nb_available_tokens, buy_oracle_priceUSD,
		user_buy_requests && user_buy_requests.length, user_sell_requests && user_sell_requests.length,
		admin_buy_requests && admin_buy_requests.length, admin_sell_requests && admin_sell_requests.length
	]
	const [is_first_call, set_is_first_call] = useState(true)
	const [log_vars_array, set_log_vars_array] = useState(curr_log_vars_array)
	if (is_first_call || !arraysAreEqual(log_vars_array, curr_log_vars_array)) {
		if (is_first_call) set_is_first_call(false)
		set_log_vars_array(curr_log_vars_array)
		let log_array = [
			"\n isloading=", isloading, ", init_state_finished=", init_state_finished,
			"\n BUY:",
			"\n\t isWrongTokenType_buy=", isWrongTokenType_buy,
			"\n\t prices =", base_price, "€, ", secondary_price, "€",
			"\n\t nb_available_tokens =", nb_available_tokens,
			"\n\t buy_oracle_priceUSD =", buy_oracle_priceUSD, "€",
			// on electron only show the length to not pollute logs
			"\n\t user_buy_requests =", (isElectron() && user_buy_requests ? user_buy_requests.length : user_buy_requests),
			"\n SELL:",
			"\n\t isWrongTokenType_sell=", isWrongTokenType_sell,
			"\n\t sell_oracle_priceUSD =", sell_oracle_priceUSD, "€",
			"\n\t user_sell_requests =", (isElectron() && user_sell_requests ? user_sell_requests.length : user_sell_requests),
			"\n\t swapbotOwner=", swapbotOwner,
			"\n\t isAdminSwapBotOwner=", isAdminSwapBotOwner,
			"\n\t hasSet_ownerIsSwapBotAdmin=", hasSet_swapbotAdmin,
		]
		if (!isAdminSwapBotOwner) {
			log_array = log_array.concat([
				"\n ADMIN:",
				"\n\t admin_buy_requests =", (isElectron() && admin_buy_requests ? admin_buy_requests.length : admin_buy_requests),
				"\n\t admin_sell_requests =", (isElectron() && admin_sell_requests ? admin_sell_requests.length : admin_sell_requests),
			])
		}
		log(...log_array)
	}

	const state =
	{
		isWrongTokenType_buy: isWrongTokenType_buy,
		isWrongTokenType_sell: isWrongTokenType_sell,

		isloading: isloading,
		reload: reload,

		refreshCounter: refreshCounter,

		base_price: base_price,
		secondary_price: secondary_price,

		nb_available_tokens: nb_available_tokens,
		history_nb_available_tokens: history_nb_available_tokens,

		user_buy_requests: user_buy_requests,
		user_sell_requests: user_sell_requests,

		// wouldnt this one be better from a function that does a sync() ?
		buy_oracle_priceUSD: buy_oracle_priceUSD,
		sell_oracle_priceUSD: sell_oracle_priceUSD,

		admin_buy_requests: admin_buy_requests,
		admin_sell_requests: admin_sell_requests,

		// public functions

		refresh_prices: refresh_prices,
		refresh_nbAvailableTokens: refresh_nbAvailableTokens,
		refresh_history_AvailableTokensContract: refresh_history_AvailableTokensContract,

		//
		// user
		//
		refresh_user_buy_requests: refresh_user_buy_requests,
		refresh_buy_oracle_priceUSD: refresh_buy_oracle_priceUSD,

		refresh_user_sell_requests: refresh_user_sell_requests,
		refresh_sell_oracle_priceUSD: refresh_sell_oracle_priceUSD,

		buyTokens: buyTokens,
		sellTokens: sellTokens,

		//
		// admin
		//
		refresh_admin_buy_requests: refresh_admin_buy_requests,
		refresh_admin_sell_requests: refresh_admin_sell_requests,

		// demandes d'achats
		send_tokens_to_user: send_tokens_to_user,
		refund_bsv_to_user: refund_bsv_to_user,

		// demandes de ventes
		send_bsv_to_user: send_bsv_to_user,
		refund_tokens_to_user: refund_tokens_to_user,
	}
	// log("state=",remove_functions_from_obj(state))
	// const jigs = run.inventory.jigs
	const jigs = runContext.get_inventory().jigs

	const txStateContext = useContext(TxStateContext)

	// check if the token type loaded fits the swapbot contracts loaded
	function set_isWrongTokenType_buy_safe(newval) {
		if (isWrongTokenType_buy !== newval)
			set_isWrongTokenType_buy(newval)
	}
	function set_isWrongTokenType_sell_safe(newval) {
		if (isWrongTokenType_sell !== newval)
			set_isWrongTokenType_sell(newval)
	}
	const current_token_origin = userContext.tokenorigin
	let buy_valid_token_origin, sell_valid_token_origin
	if (TokenBuyRequest_Admin && TokenBuyRequest_Admin.valid_token_class) {
		buy_valid_token_origin = TokenBuyRequest_Admin.valid_token_class.origin
		if (buy_valid_token_origin !== current_token_origin) {
			set_isWrongTokenType_buy_safe(true)
		} else set_isWrongTokenType_buy_safe(false)
	}
	if (TokenSellRequest_Admin && TokenSellRequest_Admin.valid_token_class) {
		sell_valid_token_origin = TokenSellRequest_Admin.valid_token_class.origin
		if (sell_valid_token_origin !== current_token_origin) {
			set_isWrongTokenType_sell_safe(true)
		} else set_isWrongTokenType_sell_safe(false)
	}
	log(
		"\n buy_valid_token_origin=", buy_valid_token_origin,
		"\n sell_valid_token_origin=", sell_valid_token_origin,
		"\n current_token_origin=", current_token_origin
	)

	//
	// ACTION FUNCTIONS
	//	

	/**
	 * this function is quite huge because it has to handle multiple steps of interactions
	 * with the oracle & retry logic
	 */
	async function buyTokens(tokenActionID, buy_nb_tokens, tokenName) {
		const function_id = classname + "buyTokens(): "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!Runcraft) throw new Error("error with Runcraft=" + JSON.stringify(Runcraft))
		log("start, buy_nb_tokens=", buy_nb_tokens)

		const tokenName_plural = tokenName + "s"

		set_popup_lock(true)
		var confirmed = await confirmPopup(
			"ACHETER " + buy_nb_tokens + " " + tokenName_plural + ". Êtes-vous sûr ?",
			"acheter"
		)
		if (!confirmed) {
			log("buy", buy_nb_tokens, "tokens was aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("buy", buy_nb_tokens, "tokens was confirmed from popup")
		}
		set_popup_lock(false)

		// helper function to update this txState
		function updateTxState(newStateDict) {
			return txStateContext.setTxState(tokenActionID, newStateDict)
		}

		try {
			await txStateContext.init_action(function_id, tokenActionID, {
				"status": txstate_buytokens_oracle.sending,
				"nb_tokens": buy_nb_tokens,
			})

			// calculate oracle fees in sats

			const TokenBuyRequest_User = Runcraft.TokenBuyRequest_User
			await TokenBuyRequest_User.sync()

			let bsvusd_user = await get_latest_BSVUSD_price()
			log("bsvusd_user=", bsvusd_user, " (for init())")

			/* // deprecated
			// calculate satoshis to pay associated oracles
			// var oracle_callFee_sats = Math.ceil(oracle_price_USD / ( 1e-8 * bsvusd ))
			var oracle_callFee_sats = Math.ceil(usd_to_sats(oracle_price_USD, bsvusd_user))
			log("oracle_callFee_sats = ",oracle_callFee_sats)
			*/

			// calculate BSV to pay for tokens
			const expected_nb_tokens_base_price = Math.min(buy_nb_tokens, nb_available_tokens)
			log("expected_nb_tokens_base_price=", expected_nb_tokens_base_price)
			var expected_nb_tokens_secondary_price = buy_nb_tokens - expected_nb_tokens_base_price
			log("expected_nb_tokens_secondary_price=", expected_nb_tokens_secondary_price)

			/* // deprecated
			var eur_buy = expected_nb_tokens_base_price * base_price
				+ expected_nb_tokens_secondary_price * secondary_price

			log("EUR_price_for_tokens_to_buy = ",eur_buy)
			const bsveur = await get_latest_BSVEUR_price()
			// BEWARE THIS ONE SHOULD BE CALCULATED WITH BSVEUR NOT BSVUSD
			// var satoshis_buy = Math.ceil(eur_buy / ( 1e-8 * bsveur ))
			var satoshis_buy = Math.ceil(eur_to_sats(eur_buy, bsveur))
			log("satoshis_buy = ",satoshis_buy)
			*/

			/* // no tokkenr fees for now
			// pay tokkenr fees
			var tokkenr_feePercent_sats = Math.ceil(get_afterPercentFee_toAdd(satoshis_buy, 0.5))
			log("tokkenr_feePercent_sats=",tokkenr_feePercent_sats,"=",sats_to_eur(tokkenr_feePercent_sats, bsveur),"€")
			var tokkenr_fees_perc_payment = new BSV_Payment(RUN_ADDRESS_TOKKENR_FEES, tokkenr_feePercent_sats)
			await tokkenr_fees_perc_payment.sync()
			log("paid tokkenr fees at "+tokkenr_fees_perc_payment.location)
			*/

			/* // deprecated
			// add oracle feePercent to satoshis_buy
			var oracleBuy_feePercent_sats = Math.ceil(get_afterPercentFee_toAdd(satoshis_buy, 1))
			log("oracleBuy_feePercent_sats=",oracleBuy_feePercent_sats,
				"=",sats_to_eur(oracleBuy_feePercent_sats, bsveur),"€",
				"to add to satoshis_buy=",satoshis_buy,
			)
			satoshis_buy += oracleBuy_feePercent_sats
			*/

			// TODO add a check for the fixed price of init() to be like <$0.1 using .get_price_usd() ?
			// example: if(TokenBuyRequest_User.get_price_USD() > 0.1) { throw new Error("price too high than expected") }

			// create TokenBuyRequest_User jig
			const token_address = run.owner.address  // where to send the tokens if order is accepted

			/* // deprecated
			const tokenClass = await userContext.get_tokenoriginjig()
			let request_args = [
				bsvusd_user, token_address, tokenClass,
			*/
			let request_args = [
				bsvusd_user, token_address,
				expected_nb_tokens_base_price, expected_nb_tokens_secondary_price
			]
			log("creating TokenBuyRequest_User with args:", request_args)

			/* // deprecated
			var myTokenBuyRequest = new TokenBuyRequest_User(
				oracle_callFee_sats, expected_nb_tokens_base_price, token_address, satoshis_buy, tokenClass, expected_nb_tokens_secondary_price
			)
			*/

			/* security check: right before creating the request, we want to resync the admin contract
			to make sure the valid_token_class is still the one we are asking for
			otherwise we abord
			*/
			const my_TokenBuyRequest_Admin = TokenBuyRequest_User.deps.TokenBuyRequest_Admin
			await my_TokenBuyRequest_Admin.sync()
			const valid_token_class = my_TokenBuyRequest_Admin.valid_token_class
			const curr_token_origin = userContext.tokenorigin
			if (valid_token_class.origin !== curr_token_origin) {
				let errmess = "type de token invalide, attendu valid_token_class.origin="
					+ valid_token_class.origin + " but got " + curr_token_origin
				throw new Error(errmess)
			}

			var myTokenBuyRequest = new TokenBuyRequest_User(...request_args)

			await myTokenBuyRequest.sync()
			log("myTokenBuyRequest successfully created at " + myTokenBuyRequest.location)

			updateTxState({ "status": txstate_buytokens_oracle.sending_step2 })

			// retry loop until oracle returns a number

			var total_EUR_paid = null
			log("starting retry loop for myTokenBuyRequest.get_total_EUR_paid() at ", myTokenBuyRequest.location)
			// var oracle_BSVEUR = myTokenBuyRequest.oracle_BSVEUR
			// var oracle_Timestamp = myTokenBuyRequest.oracle_Timestamp
			var i_retry = 0
			var send_retries = 0
			var start_timestamp = Date.now()
			updateTxState({
				"send_retries": 0 // reset
			})
			var reached_elapsed_seconds = false
			await retry(async () => {
				try {
					i_retry += 1
					log("retry " + i_retry, " for ", myTokenBuyRequest.location)

					var curr_timestamp = Date.now()
					var elapsed_seconds = (curr_timestamp - start_timestamp) / 1000

					send_retries += 1
					updateTxState({ "send_retries": send_retries })

					// first we try to sync based on run-api

					await myTokenBuyRequest.sync()
					// internally-referenced creations should be synced already but still...
					await myTokenBuyRequest.oracle_BSVEUR.sync()
					await myTokenBuyRequest.oracle_Timestamp.sync()

					var oracle_BSVEUR = myTokenBuyRequest.oracle_BSVEUR,
						oracle_Timestamp = myTokenBuyRequest.oracle_Timestamp

					let runapi_failed = true
					if (oracle_BSVEUR.value && oracle_Timestamp.value) {
						runapi_failed = false
					}

					// if no oracle response after this time limit we will add fetching blockchair spentTXid as fallback
					const fallback_fetch_secs = 30  // TODO repasse en >15 une fois amélioré avec notre run-db
					const should_call_blockchair = (runapi_failed && elapsed_seconds > fallback_fetch_secs)

					if (!should_call_blockchair) {
						if (!oracle_BSVEUR.value) {
							throw new Error("runapi: spending transaction hash is null for oracle_BSVEUR at " + oracle_BSVEUR.location)
						}
						else if (!oracle_Timestamp.value) {
							throw new Error("runapi: spending transaction hash is null for oracle_Timestamp at " + oracle_Timestamp.location)
						}
					}
					else // same as: if(should_call_blockchair){
					{
						// do only once
						if (!reached_elapsed_seconds) {
							reached_elapsed_seconds = true
							send_retries = 0 // reset
							updateTxState({
								"status": txstate_buytokens_oracle.sending_step2_toolong,
								"send_retries": 0, // reset
							})
						}

						// since it is taking too long, it might be due to run's api
						// being too slow to get new transactions (spends)
						// so we will add some fetches to blockchair which seems to be faster
						try {
							var spentTx_oracle_BSVEUR = null,
								spentTx_oracle_Timestamp = null

							// safety check: if already syncronized oracles answers
							if (oracle_BSVEUR.value) {
								spentTx_oracle_BSVEUR = oracle_BSVEUR.location
							}
							else {
								spentTx_oracle_BSVEUR = await get_spendingTxId(
									run, oracle_BSVEUR.location, function_id
								)
							}

							if (!spentTx_oracle_BSVEUR) {
								throw new Error(
									"blockchair: spending_transaction_hash is null for oracle_BSVEUR at "
									+ oracle_BSVEUR.location
								)
							}

							// safety check: if already syncronized oracles answers
							if (oracle_Timestamp.value) {
								spentTx_oracle_Timestamp = oracle_Timestamp.location
							}
							else {
								spentTx_oracle_Timestamp = await get_spendingTxId(
									run, oracle_Timestamp.location, function_id
								)
							}

							if (!spentTx_oracle_Timestamp) {
								throw new Error(
									"blockchair: spending_transaction_hash is null for oracle_Timestamp at "
									+ oracle_Timestamp.location
								)
							}

							// once we are sure to have both oracles set, we load their value manually
							log("blockchair: found spentTx_oracle_BSVEUR and spentTx_oracle_Timestamp:",
								"\n spentTx_oracle_BSVEUR=", spentTx_oracle_BSVEUR,
								"\n spentTx_oracle_Timestamp=", spentTx_oracle_Timestamp)

							await run.blockchain.cache.set(
								"spend://" + oracle_BSVEUR.location,
								spentTx_oracle_BSVEUR
							)

							await run.blockchain.cache.set(
								"spend://" + oracle_Timestamp.location,
								spentTx_oracle_Timestamp
							)

							log("blockchair: successfully added spendTx in cache for oracle_BSVEUR & oracle_Timestamp")
						}
						catch (e) {
							throw e
						}
					}

					// why does this fail ?
					// await oracle_BSVEUR.sync()
					// await oracle_Timestamp.sync()
					//total_EUR_paid = myTokenBuyRequest.get_total_EUR_paid()
				}
				catch (error) {
					console.error(function_id, error)
					throw error
				}
			}, {
				retries: 3,
				minTimeout: 500,  // in ms
				maxTimeout: 5000,  // in ms, not less than 2000 if you fetch blockchair
				factor: 2,  // exponential-backoff
			})

			updateTxState({ "status": txstate_buytokens_oracle.sending_step3 })

			log("total_EUR_paid=", total_EUR_paid)
			log("calling myTokenBuyRequest.send_to_oracle() & sync...")

			// we have a 10 min time window (based on the oracle_Timestamp.value)
			// to call send_to_oracle() after creating the request
			// after that delay the oracle will reject and refund the user
			// note: we might want to auto-resend to oracle if a contract has all the setup but wasn't sent yet
			// 		 this is a bit risky thought, as it means handling correctly the time window & priceUSD
			// 		 so for now let's turn them into "failed" ones that the user must manually retrieve & send a new one
			bsvusd_user = await get_latest_BSVUSD_price()
			log("bsvusd_user=", bsvusd_user, " (for send_to_oracle())")
			await myTokenBuyRequest.send_to_oracle(bsvusd_user)  // will take 1% fee here
			await myTokenBuyRequest.sync()
			log("success for myTokenBuyRequest.send_to_oracle()")

			// TODO handle the oracle refunding & display success/fail message with nb_tokens_to_receive
			//
			// var Oracle_TokenBuyRequest_BasePrice = myTokenBuyRequest.oracle_TokenBuyRequest_BasePrice
			// await Oracle_TokenBuyRequest_BasePrice.sync()
			// var nb_tokens_at_base_price = Oracle_TokenBuyRequest_BasePrice.value
			// var nb_tokens_at_secondary_price = total_EUR_paid - nb_tokens_at_base_price * base_price
			// var nb_tokens_to_receive = nb_tokens_at_base_price * base_price
			// 		+ nb_tokens_at_secondary_price * secondary_price
			// log(
			// 	"nb_tokens_to_receive = ",nb_tokens_to_receive,
			// 	" (",nb_tokens_at_base_price," + ",nb_tokens_at_secondary_price,")"
			// )

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				myTokenBuyRequest.location, null,
				{ "status": txstate_buytokens_oracle.sentsuccess },
				async () => {
					refresh_user_buy_requests()
					refresh_nbAvailableTokens()
					userContext.update_balance_bsv()
				}
			)
		}
		catch (error) {
			// updateTxState({"status": txstate_buytokens_oracle.sentfail})
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: l'oracle n'a pas répondu à la demande ou le wallet n'a pas réussi à synchroniser.",
				{ "status": txstate_buytokens_oracle.sentfail },
				async () => {
					refresh_user_buy_requests()
					refresh_nbAvailableTokens()
				}
			)
		}
	}

	async function sellTokens(tokenActionID, sell_nb_tokens, tokenName) {
		const function_id = classname + "sellTokens(): "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!Runcraft) throw new Error("error with Runcraft=" + JSON.stringify(Runcraft))
		log("start, sell_nb_tokens=", sell_nb_tokens)

		const tokenName_plural = tokenName + "s"

		set_popup_lock(true)
		var confirmed = await confirmPopup(
			"VENDRE " + sell_nb_tokens + " " + tokenName_plural + ". Êtes-vous sûr ?",
			"vendre"
		)
		if (!confirmed) {
			log("sell", sell_nb_tokens, "tokens was aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("sell", sell_nb_tokens, "tokens was confirmed from popup")
		}
		set_popup_lock(false)

		try {
			const specific_state = {
				"nbtokens": sell_nb_tokens,
			}
			await txStateContext.init_action(function_id, tokenActionID, specific_state)

			// calculate oracle fees in sats

			const TokenSellRequest_User = Runcraft.TokenSellRequest_User
			await TokenSellRequest_User.sync()

			const bsvusd_user = await get_latest_BSVUSD_price()
			log("bsvusd_user=", bsvusd_user)

			// where to refund the tokens if order is cancelled
			// and where to receive the BSVs from the sale (to melt)
			const user_owner_address = run.owner.address

			// tokens to sell for bsv

			// for that we need to do a combine+send_to_ourselves to be able to put exactly
			// the right amount of tokens into the request contract

			var get_utxos_for_nbtokens = await userContext.get_utxos_for_nbtokens(sell_nb_tokens)
			var tokenstosend_jigstocombine = get_utxos_for_nbtokens[0]
			var amount_to_send = get_utxos_for_nbtokens[1]

			const TokenClass = tokenstosend_jigstocombine[0].constructor

			var combinedtokens = undefined
			if (tokenstosend_jigstocombine && tokenstosend_jigstocombine.length >= 2) {
				log("combining tokens to add")
				combinedtokens = new TokenClass(Date.now(), ...tokenstosend_jigstocombine)
				await combinedtokens.sync() // TODO do it in the same tx as "new TokenSellRequest_User(..."
			}
			else {
				log("no need to combine tokens")
				combinedtokens = tokenstosend_jigstocombine[0]
			}

			const timestamp_user = Date.now()
			const request_args = [
				bsvusd_user, combinedtokens,
				user_owner_address, timestamp_user, amount_to_send
			]
			log("creating TokenSellRequest_User with args:", request_args)

			var myTokenSellRequest = new TokenSellRequest_User(...request_args)
			await myTokenSellRequest.sync()

			log("myTokenSellRequest successfully created at "
				+ myTokenSellRequest.location)

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				myTokenSellRequest.location, null,
				null, async () => {
					refresh_user_sell_requests()
					refresh_nbAvailableTokens()
				}
			)

		}
		catch (error) {
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					refresh_user_sell_requests()
					refresh_nbAvailableTokens()
				}
			)
		}
	}

	async function send_tokens_to_user(tokenActionID, tokenName, request_location, nb_tokens) {
		const function_id = classname + "send_tokens_to_user(): (nb_tokens=" + String(parseInt(nb_tokens))
			+ ", request_location=" + String(request_location) + "): "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!run) throw new Error("run is undefined")
		log("start, nb_tokens=", nb_tokens, "request_location=", request_location)
		const tokenName_plural = tokenName + "s"

		set_popup_lock(true)
		var confirmed = await confirmPopup("Envoyer " + String(parseInt(nb_tokens)) + " " + tokenName_plural + ". Êtes-vous sûr ?",
			"Envoyer")
		if (!confirmed) {
			log("aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("confirmed from popup")
		}
		set_popup_lock(false)

		try {
			// TODO reactivate these intermediary status updates to display to the user
			// do like updateTxState()
			// this.setState({ send_status_mess: "Synchronisation du contrat..." })

			const specific_state = {
				"request_location": request_location,
				"nbtokens": nb_tokens,
				"type": "send_tokens",
			}
			await txStateContext.init_action(function_id, tokenActionID, specific_state)

			log("doing run.sync()...")
			run.activate()
			await run.sync()

			log("doing requestJig.sync()...")
			var requestJig = await run.load(request_location)
			await requestJig.sync()
			log("called: requestJig=", requestJig)

			// tokens to sell for bsv

			// for that we need to do a combine+send_to_ourselves to be able to put exactly
			// the right amount of tokens into the request contract

			// this.setState({ send_status_mess: "Calcul du nombre de tokens à envoyer..." })
			var get_utxos_for_nbtokens = await userContext.get_utxos_for_nbtokens(nb_tokens)
			log("get_utxos_for_nbtokens = ", get_utxos_for_nbtokens)
			var tokenstosend_jigstocombine = get_utxos_for_nbtokens[0]
			var amount_to_send = get_utxos_for_nbtokens[1]

			var combinedtokens = undefined
			if (tokenstosend_jigstocombine && tokenstosend_jigstocombine.length >= 2) {
				// this.setState({ send_status_mess: "Combinaison des tokens à envoyer..." })
				const TokenClass = tokenstosend_jigstocombine[0].constructor
				await TokenClass.sync()
				log("combining tokens to add:",
					"\n TokenClass.location=", TokenClass.location,
					"\n TokenClass.origin=", TokenClass.origin,
					// "\n TokenClass=",TokenClass,
					"\n tokenstosend_jigstocombine constructor.location=",
					tokenstosend_jigstocombine.map(e => e.constructor.location),
					"\n amounts=", tokenstosend_jigstocombine.map(e => e.amount))
				// don't display tokenstosend_jigstocombine or it will give a black screen with :
				// "Error: Cannot read location. Hint: Sync the jig to assign it in a transaction"
				//"\n\n tokenstosend_jigstocombine=",tokenstosend_jigstocombine)
				combinedtokens = new TokenClass(Date.now(), ...tokenstosend_jigstocombine)
				// syncing them onchain first seems to prevent many errors
				log("syncing combinedtokens...")
				await combinedtokens.sync()
				log("combining success!")
			} else {
				log("no need to combine tokens")
				combinedtokens = tokenstosend_jigstocombine[0]
			}

			// this.setState({ send_status_mess: "Envoi des tokens..." })
			// from contract: pay_tokens(tokens_jig, paid_timestamp, amount_to_send)
			let pay_args = [
				combinedtokens, Date.now(), amount_to_send
			]
			log("calling pay_tokens() with args=", pay_args)
			requestJig.pay_tokens(...pay_args)
			await requestJig.sync()

			log("success: requestJig=", requestJig)
			// this.setState({ send_status_mess: "Envoi de tokens réussi" })

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				requestJig.location, null,
				null, async () => {
					refresh_admin_buy_requests()
					userContext.update_balance_bsv()
				}
			)
		}
		catch (error) {
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					refresh_admin_buy_requests()
				}
			)
		}
	}

	async function refund_bsv_to_user(tokenActionID, tokenName, request_location) {
		const function_id = classname + "refund_bsv_to_user(): request_location=" + String(request_location) + ": "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!run) throw new Error("run is undefined")
		log("start")
		// const tokenName_plural = tokenName+"s"

		set_popup_lock(true)
		var confirmed = await confirmPopup("Rembouser les BSV. Êtes-vous sûr ?", "Rembourser")
		if (!confirmed) {
			log("aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("confirmed from popup")
		}
		set_popup_lock(false)

		try {
			// TODO reactivate, do like updateTxState()
			// this.setState({ send_status_mess: "Synchronisation du contrat..." })

			const specific_state = {
				"request_location": request_location,
				"type": "refund",
			}
			await txStateContext.init_action(function_id, tokenActionID, specific_state)

			run.activate()
			var requestJig = await run.load(request_location)
			await requestJig.sync()
			log("called: requestJig=", requestJig)
			log("calling requestJig.cancel_order()...")
			// this.setState({ send_status_mess: "Envoi du remboursement des BSV..." })

			var message = "Admin cancelled and refunded BSV."
			requestJig.cancel_order(Date.now(), message)
			await requestJig.sync()

			log("success: requestJig=", requestJig)
			// this.setState({ send_status_mess: "Remboursement des BSV réussi" })

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				requestJig.location, null,
				null, async () => {
					refresh_admin_buy_requests()
					userContext.update_balance_bsv()
				}
			)
		}
		catch (error) {
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					refresh_admin_buy_requests()
				}
			)
		}
	}

	async function send_bsv_to_user(
		tokenActionID, tokenName, request_location, EUR_to_pay, paid_for_nb_tokens, paid_for_base_price
	) {
		const function_id = classname + "send_bsv_to_user(): EUR_to_pay=" + String(parseInt(EUR_to_pay))
			+ ", request_location=" + String(request_location) + ": "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!run) throw new Error("run is undefined")
		log("start")
		// const tokenName_plural = tokenName+"s"

		set_popup_lock(true)
		var confirmed = await confirmPopup("Envoyer " + String(EUR_to_pay) + "€  (en échange des " + String(paid_for_nb_tokens) + " tokens). Êtes-vous sûr ?",
			"Envoyer")
		if (!confirmed) {
			log("aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("confirmed from popup")
		}
		set_popup_lock(false)

		try {
			// TODO reactivate these intermediary status updates to display to the user
			// do like updateTxState()
			// this.setState({ send_status_mess: "Synchronisation du contrat..." })

			const specific_state = {
				"request_location": request_location,
				"EUR_to_pay": EUR_to_pay,
				"type": "send_bsv",
			}
			await txStateContext.init_action(function_id, tokenActionID, specific_state)

			log("doing run.sync()...")
			run.activate()
			await run.sync()

			log("doing requestJig.sync()...")
			var requestJig = await run.load(request_location)
			await requestJig.sync()
			log("called: requestJig=", requestJig)

			const bsveur = await get_latest_BSVEUR_price()
			const total_sats_to_pay = Math.ceil(eur_to_sats(EUR_to_pay, bsveur))

			log("calling requestJig.pay_bsv() to pay EUR_to_pay=",
				EUR_to_pay, "€ = total_sats_to_pay=", total_sats_to_pay,
				" (with bsveur=", bsveur, ")")

			// calculate tokkenr fees
			// update 25.06.2022: we don't want the admin to pay fees on top but to deduce the fees from the amount directly
			// var fees_perc_tokkenr_sats = Math.ceil(get_afterPercentFee_toAdd(satoshis_to_pay, 1))  // 1% fee all going to tokkenr
			// var total_sats_to_pay = satoshis_to_pay + fees_perc_tokkenr_sats
			var fees_perc_tokkenr_sats = parseInt(total_sats_to_pay * 0.01)
			var sats_to_pay_user = parseInt(total_sats_to_pay - fees_perc_tokkenr_sats)

			// safety check

			log("total_sats_to_pay=", total_sats_to_pay, "=", sats_to_eur(total_sats_to_pay, bsveur), "€",
				"fees_perc_tokkenr_sats=", fees_perc_tokkenr_sats, "=", sats_to_eur(fees_perc_tokkenr_sats, bsveur), "€",
				", sats_to_pay_user=", sats_to_pay_user, "=", sats_to_eur(sats_to_pay_user, bsveur), "€")

			// for safety we check that the difference is no more than 10 sats (which is almost 0.00€)
			// but using a value >0 should reduce errors raised
			let diff_sats = (total_sats_to_pay * 0.99) - (total_sats_to_pay - fees_perc_tokkenr_sats)
			diff_sats = Math.abs(diff_sats)
			if (diff_sats > 10) {
				throw new Error("Erreur lors du safety check du calcul des 1% de frais TokkenR:" +
					+" total_sats_to_pay=" + total_sats_to_pay + ", fees_perc_tokkenr_sats=" + fees_perc_tokkenr_sats
					+ ", sats_to_pay_user=" + sats_to_pay_user)
			}

			// make sure we have enough bsv
			var balance_bsv = await run.purse.balance()
			var estimate_cost_of_txs = eur_to_sats(0.005) * 2 // *2 because 2 txs: tokkenr fee + pay_bsv() call
			if (balance_bsv < total_sats_to_pay + estimate_cost_of_txs) {
				throw new Error("pas assez de BSV dans le wallet: requiert "
					+ sats_to_eur(total_sats_to_pay, bsveur) + "€ de BSV"
					+ ", vous avez actuellement " + sats_to_eur(balance_bsv, bsveur) + "€ de BSV."
				)
			}

			// pay tokkenr fees
			var tokkenr_fees_perc_payment = new BSV_Payment(RUN_ADDRESS_TOKKENR_FEES, fees_perc_tokkenr_sats)
			await tokkenr_fees_perc_payment.sync()
			log("sent tokkenr fees at " + tokkenr_fees_perc_payment.location)

			// this.setState({
			// 	send_status_mess: "Envoi du paiement en BSV..."
			// })
			requestJig.pay_bsv(sats_to_pay_user, Date.now(), bsveur, paid_for_nb_tokens, paid_for_base_price)
			await requestJig.sync()

			log("success: userRequest=", requestJig)
			// this.setState({ send_status_mess: "Envoi de BSV réussi" })

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				requestJig.location, null,
				null, async () => {
					refresh_admin_sell_requests()
					userContext.update_balance_bsv()
				}
			)
		}
		catch (error) {
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					refresh_admin_sell_requests()
				}
			)
		}
	}

	async function refund_tokens_to_user(tokenActionID, tokenName, request_location) {
		const function_id = classname + "refund_tokens_to_user(): "
			+ "(request_location=" + String(request_location) + "): "
		const log = getLog(function_id)

		if (txStateContext.broadcast_lock || popup_lock) return
		if (!run) throw new Error("run is undefined")
		log("start")
		const tokenName_plural = tokenName + "s"

		set_popup_lock(true)
		var confirmed = await confirmPopup("Rembourser les " + tokenName_plural + ". Êtes-vous sûr ?", "Rembourser")
		if (!confirmed) {
			log("aborted from popup")
			set_popup_lock(false)
			return // very important to return here!
		} else {
			log("confirmed from popup")
		}
		set_popup_lock(false)

		try {
			// TODO reactivate, do like updateTxState()
			// this.setState({send_status_mess: "Synchronisation du contrat..."})

			const specific_state = {
				"request_location": request_location,
				"type": "refund",
			}
			await txStateContext.init_action(function_id, tokenActionID, specific_state)

			run.activate()
			var requestJig = await run.load(request_location)
			await requestJig.sync()
			log("called: requestJig=", requestJig)
			log("calling requestJig.cancel_request()...")

			var balance = await run.purse.balance()
			log("purse balance = ", balance)

			// this.setState({ send_status_mess: "Calcul du nombre de tokens à envoyer..." })

			// TODO replace this entire block by a new context.get_utxos_for_amount(..) that does this
			// 		and that is used in get_utxos_for_nbtokens()
			var amount_to_send = requestJig.amount_to_send + 1 // amount+1 for safety
			log("amount_to_send = ", amount_to_send)
			var totalmultiplicators = await userContext.get_total_mult()
			var MyToken = await userContext.get_tokenoriginjig()
			await MyToken.sync()
			var decimals = MyToken.decimals
			var nb_tokens_to_send = amount_to_send / Math.pow(10, decimals) * totalmultiplicators
			log("nb_tokens_to_send = ", nb_tokens_to_send)

			var get_utxos_for_nbtokens = await userContext.get_utxos_for_nbtokens(nb_tokens_to_send)
			log("get_utxos_for_nbtokens = ", get_utxos_for_nbtokens)
			var tokenstosend_jigstocombine = get_utxos_for_nbtokens[0]
			amount_to_send = get_utxos_for_nbtokens[1]

			// this.setState({ send_status_mess: "Combinaison des tokens à envoyer..." })

			var combinedtokens = undefined
			if (tokenstosend_jigstocombine && tokenstosend_jigstocombine.length >= 2) {
				const TokenClass = tokenstosend_jigstocombine[0].constructor
				log("combining tokens to add, TokenClass=", TokenClass)
				// don't display tokenstosend_jigstocombine or it will give a black screen with :
				// "Error: Cannot read location. Hint: Sync the jig to assign it in a transaction"
				//"\n\n tokenstosend_jigstocombine=",tokenstosend_jigstocombine)
				combinedtokens = new TokenClass(Date.now(), ...tokenstosend_jigstocombine)
				// syncing them onchain first seems to prevent many errors
				await combinedtokens.sync()
			} else {
				log("no need to combine tokens")
				combinedtokens = tokenstosend_jigstocombine[0]
			}

			// this.setState({send_status_mess: "Envoi du remboursement des tokens..."})
			var message = "Admin cancelled and refunded tokens."
			const timestamp = Date.now()
			const refund_nb_tokens = nb_tokens_to_send
			const refund_base_price = base_price
			let cancel_args = [
				combinedtokens, timestamp, refund_nb_tokens, refund_base_price, message
			]
			log("calling cancel_request() with args=", cancel_args)
			requestJig.cancel_request(...cancel_args)
			await requestJig.sync()

			log("success: userRequest=", requestJig)
			// this.setState({ send_status_mess: "Remboursement de tokens réussi" })

			txStateContext.sendtx_deal_with_success(
				function_id, tokenActionID,
				requestJig.location, null,
				null, async () => {
					refresh_admin_sell_requests()
					userContext.update_balance_bsv()
				}
			)
		}
		catch (error) {
			return txStateContext.deal_with_error_RETURN(
				function_id, tokenActionID, error,
				"Erreur: le wallet n'a pas réussi à synchroniser.",
				null, async () => {
					refresh_admin_sell_requests()
				}
			)
		}
	}

	//
	// REFRESH FUNCTIONS
	//
	function has_all_required(required_array) {
		return required_array.every(e => !!e)
	}

	// these locks are used to not call refresh functions multiple times on first load
	// we must a ref because we might update more than one lock per component refresh
	const _ref_locks = useRef({})
	const _locks = _ref_locks.current // make it easier to use // checked and this works well
	// usage: if(_locks[function_id]) return
	const _take_lock = (lockname) => {
		_ref_locks.current[lockname] = true
	}
	function _release_lock(lockname) {
		_ref_locks.current[lockname] = false

		const bool_all_locks_false = Object.values(_locks).every((v) => v === false)
		log("_release_lock: _locks=", _locks,
			"\n Object.values(_locks)=", Object.values(_locks),
			"\n bool_all_locks_false=", bool_all_locks_false,
			"\n init_state_finished=", init_state_finished,
			"\n isloading=", isloading,
			"\n state.isloading=", state.isloading,
			"\n refreshCounter=", refreshCounter,
		)
		if (bool_all_locks_false) {
			// you can't do if(isloading) set_isloading(false) here because it's not a ref ! so you only get the value of your execution
			// you check it & debug it using the refreshCounter log between inside this function vs outside
			log("doing: set_isloading(false); set_init_state_finished(true);")
			set_isloading(false)
			set_init_state_finished(true)
		}
	}
	// log(
	// 	"\n init_state_finished=",init_state_finished,
	// 	"\n isloading=",isloading,
	// 	"\n state.isloading=",state.isloading,
	// 	"\n refreshCounter=",refreshCounter,
	// )

	async function _sync_jig(jig) {
		// allows to pass a null/undefined or a jig and if it's a jig we sync it
		if (jig) await jig.sync()
	}

	async function _sync_and_melt_BSV_Refund(BSV_Refund) {
		const function_id = classname + "_sync_and_melt_BSV_Refund(): "
		if (!BSV_Refund) return
		// same as sync_jig but will also melt if possible
		try {
			await BSV_Refund.sync()
			if (BSV_Refund.satoshis > 0) {
				log("melting BSV_Refund:", BSV_Refund)
				await BSV_Refund.melt()
				await BSV_Refund.sync()
				log("metled BSV_Refund:", BSV_Refund)
				userContext.update_balance_bsv()
				// TODO catch and display error about need for more bsv to melt ? quite paradoxal
			}
		} catch (e) {
			/* we can have errors where we try to melt jigs that are not in their latest state
			because they are not indexed by the node (old test contracts for example)*/
			const error_mess = function_id + "Error catched for location " + BSV_Refund.location + ":" + e
			log("Error:", error_mess)
			console.error(error_mess, e)

			// why retry if it already failed ? seems useless
			// setTimeout(() => { _sync_and_melt_BSV_Refund(BSV_Refund) }, RETRY_REFRESH_AFTER_MS)
		}
	}

	async function refresh_admin_sell_requests(params = {}) {
		/*
		 * args: dict with:
		 * 		inventory_sync: boolean, defaults to true
		 */
		var inventory_sync = true  // default

		const function_id = classname + "refresh_admin_sell_requests(): "
		const log = (...args) => { console.log(function_id, "(inventory_sync=" + inventory_sync + "): ", ...args) }

		// only on initial load, wait for inventory to have synced first (otherwise it's too slow)
		const required_array = [run, Runcraft, TokenSellRequest_Admin, !_locks[function_id], inventory_synced_atLeastOnce]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		/* need to trycatch because we get this error from time to time on first load:
		Error: [jig Oracle_Timestamp] not found in the transaction
		*/
		try {
			log("start, inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce)

			if (inventory_sync) {
				await userContext.inventory_sync()
				log("inventory synced")
			}

			await TokenSellRequest_Admin.sync()
			var admin_sell_requests = jigs.filter(jig => jig instanceof TokenSellRequest_Admin)
			// very important otherwise it is a security risk => filter only the requests for the current token contract
			admin_sell_requests = admin_sell_requests.filter(jig => jig.tokens.constructor.origin === userContext.tokenorigin)
			log("admin_sell_requests=", admin_sell_requests)

			// sync sub oracles

			// sync all in parallel with Promise.all or .allSettled(...)
			var all_promises = []
			for (let i = 0; i < admin_sell_requests.length; i++) {
				var admin_request = admin_sell_requests[i]
				all_promises.push(_sync_jig(admin_request))

				if ("oracle_Timestamp" in admin_request && !admin_request.oracle_Timestamp.value) {
					all_promises.push(_sync_jig(admin_request.oracle_Timestamp))
				}
			}
			log("syncing", all_promises.length, "subcontracts...", all_promises)
			//allSettled necesary because we get sometime: "Error: X  not found in the transaction"
			// await Promise.all(all_promises) // breaks execution if some reject
			await Promise.allSettled(all_promises) // passes no matter is some reject
			log("finished syncing", all_promises.length, "subcontracts:", all_promises)

			// sort admin_requests to display latest first
			admin_sell_requests.sort((a, b) => {
				a = a.get_timestamp() || Number.MAX_SAFE_INTEGER
				b = b.get_timestamp() || Number.MAX_SAFE_INTEGER
				if (a < b) return 1
				if (a > b) return -1
				return 0
			})

			// we update if we have new requests, but we must also update if their status changed
			let need_update = false
			if (!state.admin_requests || admin_sell_requests.length > state.admin_sell_requests.length) {
				need_update = true
			}
			else {
				log("testing if status changed...")
				// test if status changed
				if (JSON.stringify(state.admin_sell_requests.map(jig => jig.get_status()))
					!== JSON.stringify(admin_sell_requests.map(jig => jig.get_status()))) {
					need_update = true
				}
				// TODO same for oracles properties ?
			}

			if (need_update) {
				log("need_update for admin_sell_requests")
				set_admin_sell_requests(admin_sell_requests)
			} else log("no need to update")
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (state.admin_sell_requests == null) setTimeout(() => {
				refresh_admin_sell_requests(params)
			}, RETRY_REFRESH_AFTER_MS)
		}

		_release_lock(function_id)
	}

	async function refresh_admin_buy_requests(params = {}) {
		/*
		 * args: dict with:
		 * 		inventory_sync: boolean, defaults to true
		 */
		var inventory_sync = true  // default

		const function_id = classname + "refresh_admin_buy_requests(): "
		const log = (...args) => { console.log(function_id, "(inventory_sync=" + inventory_sync + "): ", ...args) }

		// only on initial load, wait for inventory to have synced first (otherwise it's too slow)
		const required_array = [run, Runcraft, TokenBuyRequest_Admin, !_locks[function_id], inventory_synced_atLeastOnce]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		/* need to trycatch because we get this error from time to time on first load:
		Error: [jig Oracle_Timestamp] not found in the transaction
		*/
		try {
			log("start, inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce)

			if (inventory_sync) {
				await userContext.inventory_sync()
				log("inventory synced")
			}

			await TokenBuyRequest_Admin.sync()
			var admin_buy_requests = jigs.filter(jig => jig instanceof TokenBuyRequest_Admin)
			log(admin_buy_requests.length, "valid admin_buy_requests (out of", jigs.length, "jigs) =", admin_buy_requests)

			let display_jigs = []
			for (let i = 0; i < jigs.length; i++) {
				let jig = jigs[i]
				display_jigs.push([i, jig instanceof TokenBuyRequest_Admin, jig.location, jig.constructor.origin])
			}
			log("TokenBuyRequest_Admin.origin=", TokenBuyRequest_Admin.origin,
				"\n vs [i, instanceof, location, jig.constructor.origin]:\n",
				display_jigs
			)

			// important: filter only the requests for the current token contract
			admin_buy_requests = admin_buy_requests.filter(jig => !!jig.constructor.valid_token_class) // only those with a constructor.valid_token_class
			admin_buy_requests = admin_buy_requests.filter(jig => jig.constructor.valid_token_class.origin === userContext.tokenorigin)
			log("admin_buy_requests with right valid_token_class =", admin_buy_requests)

			// sync sub oracles

			// sync all in parallel with Promise.all or .allSettled(...)
			var all_promises = []
			for (let i = 0; i < admin_buy_requests.length; i++) {
				var admin_request = admin_buy_requests[i]
				all_promises.push(_sync_jig(admin_request))

				var oracle_Timestamp = admin_request.caller.caller.oracle_Timestamp
				// log("admin_request=",admin_request,"\n oracle_Timestamp=",oracle_Timestamp)

				if (oracle_Timestamp && !oracle_Timestamp.value) {
					all_promises.push(_sync_jig(oracle_Timestamp))
				}
			}
			log("syncing", all_promises.length, "subcontracts...", all_promises)
			//allSettled necesary because we get sometime: "Error: X  not found in the transaction"
			// await Promise.all(all_promises) // breaks execution if some reject
			await Promise.allSettled(all_promises) // passes no matter is some reject
			log("finished syncing", all_promises.length, "subcontracts:", all_promises)

			// sort admin_requests to display latest first
			admin_buy_requests.sort((a, b) => {
				a = a.get_timestamp() || Number.MAX_SAFE_INTEGER
				b = b.get_timestamp() || Number.MAX_SAFE_INTEGER
				if (a < b) return 1
				if (a > b) return -1
				return 0
			})

			// we update if we have new requests, but we must also update if their status changed
			let need_update = false
			if (!state.admin_requests || admin_buy_requests.length > state.admin_buy_requests.length) {
				need_update = true
			}
			else {
				// test if status changed
				if (JSON.stringify(state.admin_buy_requests.map(jig => jig.get_status()))
					!== JSON.stringify(admin_buy_requests.map(jig => jig.get_status()))) {
					need_update = true
				}
				// TODO same for oracles properties ?
			}

			if (need_update) {
				log("need_update for admin_buy_requests")
				set_admin_buy_requests(admin_buy_requests)
			}
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (state.admin_buy_requests == null) setTimeout(() => { refresh_admin_buy_requests(params) }, RETRY_REFRESH_AFTER_MS)
		}
		_release_lock(function_id)
	}

	/**
	 * loads / refreshes base & secondary prices
	 */
	async function refresh_prices() {
		const function_id = classname + "refresh_prices(): "
		const log = getLog(function_id)

		const required_array = [TokenBuyRequest_Admin, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		/* need to trycatch because we get this error from time to time on first load:
		Error catched: Error: TokenBuyRequest_Admin not found in the transaction
		*/
		try {
			await TokenBuyRequest_Admin.sync()

			var new_base_price = TokenBuyRequest_Admin.token_base_price_EUR
			var new_secondary_price = TokenBuyRequest_Admin.token_secondary_price_EUR

			// beware at first there is no value so we inject 0
			if (!new_base_price) new_base_price = 0
			if (!new_secondary_price) new_secondary_price = 0

			log(" new_base_price = ", new_base_price, " & new__secondary_price=", new_secondary_price)

			const need_update = (state.base_price !== new_base_price
				|| state.secondary_price !== new_secondary_price
			)

			if (need_update) {
				set_base_price(new_base_price)
				set_secondary_price(new_secondary_price)
			}
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (!isNumber(state.base_price) || !isNumber(state.secondary_price)) {
				setTimeout(() => { refresh_prices() }, RETRY_REFRESH_AFTER_MS)
			}
		}
		_release_lock(function_id)
	}

	/**
	 * loads / refreshes nb_available_tokens (available at base price)
	 */
	async function refresh_nbAvailableTokens() {
		const function_id = classname + "refresh_nbAvailableTokens(): "
		const log = getLog(function_id)

		const required_array = [TokenBuyRequest_Admin, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		/* need to trycatch because we get this error from time to time on first load:
		Error catched: Error: TokenBuyRequest_Admin not found in the transaction
		*/
		try {
			log("syncing !!TokenBuyRequest_Admin=", !!TokenBuyRequest_Admin)
			try {
				await TokenBuyRequest_Admin.sync()
			} catch (e) {
				console.error(function_id + "Error catched when doing await TokenBuyRequest_Admin.sync():", e)
			}

			log("synced TokenBuyRequest_Admin:",
				"\n nonce    =", TokenBuyRequest_Admin.nonce,
				"\n location =", TokenBuyRequest_Admin.location,
				"\n origin   =", TokenBuyRequest_Admin.origin,
			)

			const myAvailableTokensContract = TokenBuyRequest_Admin.AvailableTokensContract
			var nb_available_tokens = null
			if (myAvailableTokensContract) { // at first there isn't one so we must check!
				await myAvailableTokensContract.sync()
				// 27.01.2022 I did some shit on the contract and replace nb_available_tokens by init_nb_available_tokens
				// just on constructor, so using this to deal with it until I redeploy 
				if (myAvailableTokensContract.hasOwnProperty("nb_available_tokens")) {
					nb_available_tokens = myAvailableTokensContract.nb_available_tokens
				} else {
					nb_available_tokens = myAvailableTokensContract.init_nb_available_tokens
				}
			}

			// beware at first there is no value so we inject 0
			if (!nb_available_tokens) nb_available_tokens = 0

			log("nb_available_tokens=", nb_available_tokens,
				"\n from myAvailableTokensContract.location=", myAvailableTokensContract.location,
				"\n from TokenBuyRequest_Admin.location=", TokenBuyRequest_Admin.location,
			)

			const need_update = (state.nb_available_tokens !== nb_available_tokens)
			if (need_update) {
				set_nb_available_tokens(nb_available_tokens)
			}
		}
		catch (e) {
			console.error(function_id + "Error catched:", e)
			if (!isNumber(state.nb_available_tokens)) setTimeout(() => { refresh_nbAvailableTokens() }, RETRY_REFRESH_AFTER_MS)
		}
		_release_lock(function_id)
	}

	async function refresh_history_AvailableTokensContract() {
		const function_id = classname + "refresh_history_AvailableTokensContract(): "
		const log = getLog(function_id)

		const required_array = [TokenBuyRequest_Admin, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		try {
			await TokenBuyRequest_Admin.sync()
			const new_history = TokenBuyRequest_Admin.history_AvailableTokensContract

			var new_history_values = []
			if (new_history) {
				// added .init_nb_available_tokens recently, not sure if deployed yet
				new_history_values = new_history.map(e => e.init_nb_available_tokens || e.nb_available_tokens)
				new_history_values = new_history_values.reverse()
				log("new_history_values=", new_history_values)
			}

			const need_update = (
				(new_history_values && !state.history_nb_available_tokens)
				|| new_history_values.length > state.history_nb_available_tokens.length
			)

			if (need_update) {
				set_history_nb_available_tokens(new_history_values)
			}
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (state.history_nb_available_tokens == null) {
				setTimeout(() => {
					refresh_history_AvailableTokensContract()
				}, RETRY_REFRESH_AFTER_MS)
			}
		}
		_release_lock(function_id)
	}

	async function refresh_sell_oracle_priceUSD() {
		const function_id = classname + "refresh_sell_oracle_priceUSD(): "
		const log = getLog(function_id)

		const required_array = [TokenSellRequest_User, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		try {
			await TokenSellRequest_User.sync()
			log("TokenSellRequest_User.location =", TokenSellRequest_User.location)
			let new_oracle_priceUSD = TokenSellRequest_User.get_price_USD()

			// at first there is no value so we inject 0
			if (!new_oracle_priceUSD) new_oracle_priceUSD = 0

			if (new_oracle_priceUSD) {
				if (!state.sell_oracle_priceUSD
					|| new_oracle_priceUSD !== state.sell_oracle_priceUSD
				) {
					set_sell_oracle_priceUSD(new_oracle_priceUSD)
				}
			}
		}
		catch (e) {
			console.error(function_id + "Error catched:", e)
			if (!isNumber(state.sell_oracle_priceUSD)) setTimeout(() => { refresh_sell_oracle_priceUSD() }, RETRY_REFRESH_AFTER_MS)
		}
		_release_lock(function_id)
	}

	async function refresh_buy_oracle_priceUSD() {
		const function_id = classname + "refresh_buy_oracle_priceUSD(): "
		const log = getLog(function_id)

		const required_array = [TokenBuyRequest_User, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		try {
			await TokenBuyRequest_User.sync()
			log("TokenBuyRequest_User.location =", TokenBuyRequest_User.location)
			let new_oracle_priceUSD = TokenBuyRequest_User.get_price_USD()

			// at first there is no value so we inject 0
			if (!new_oracle_priceUSD) new_oracle_priceUSD = 0

			if (new_oracle_priceUSD) {
				if (!state.buy_oracle_priceUSD
					|| new_oracle_priceUSD !== state.buy_oracle_priceUSD
				) {
					set_buy_oracle_priceUSD(new_oracle_priceUSD)
				}
			}
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (!isNumber(state.buy_oracle_priceUSD)) setTimeout(() => { refresh_buy_oracle_priceUSD() }, RETRY_REFRESH_AFTER_MS)
		}
		_release_lock(function_id)
	}

	async function refresh_user_sell_requests(params = {}) {
		/*
		 * args: dict with:
		 * 		inventory_sync: boolean, defaults to true
		 */
		var inventory_sync = true  // default
		if (params.hasOwnProperty('inventory_sync')) inventory_sync = params['inventory_sync']
		const function_id = classname + "refresh_user_sell_requests():"
		const log = (...args) => { console.log(function_id, "(inventory_sync=" + inventory_sync + "): ", ...args) }

		// only on initial load, wait for inventory to have synced first (otherwise it's too slow)
		const required_array = [run, Runcraft, TokenSellRequest_User, inventory_synced_atLeastOnce, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		try {
			log("start, inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce,
				"!!TokenSellRequest_User=", !!TokenSellRequest_User,
				"TokenSellRequest_User.location=", TokenSellRequest_User.location,
			)

			if (inventory_sync) {
				await userContext.inventory_sync()
				log("inventory synced")
			}

			await TokenSellRequest_User.sync()
			log("filtering 1...")
			var user_sell_requests = jigs.filter(jig => jig instanceof TokenSellRequest_User)
			log("filtering 2...")
			// log("user_sell_requests=",user_sell_requests)

			// important: filter only the requests for the current token contract
			const tokenorigin = userContext.tokenorigin
			log("tokenorigin=", tokenorigin, "vs user_requests =>",
				user_sell_requests.map(jig => jig.tokens.constructor.origin)
			)
			user_sell_requests = user_sell_requests.filter(
				jig => jig.tokens.constructor.origin === tokenorigin
			)
			log("user_sell_requests=", user_sell_requests)

			// sync sub oracles

			async function _sync_TokenSellRequest_Admin_and_subs(user_request) {
				let user_request_loc = user_request.location
				await user_request.sync({ inner: false })  // inner:false to not auto-sync inner .tokens !

				const tokenSellRequest_Admin = user_request.tokenSellRequest_Admin

				log("(user_request_loc=", user_request_loc, "): NOT synced TokenSellRequest_Admin=", tokenSellRequest_Admin)
				await tokenSellRequest_Admin.sync()

				log("(user_request_loc=", user_request_loc, "): synced TokenSellRequest_Admin=", tokenSellRequest_Admin)

				log("(user_request_loc=", user_request_loc, "): synced TokenSellRequest_Admin.oracle_Timestamp=", tokenSellRequest_Admin.oracle_Timestamp)
				let cond = ("oracle_Timestamp" in tokenSellRequest_Admin && !tokenSellRequest_Admin.oracle_Timestamp.value)
				log("(user_request_loc=", user_request_loc, "): cond=", cond)

				if ("oracle_Timestamp" in tokenSellRequest_Admin && !tokenSellRequest_Admin.oracle_Timestamp.value) {
					// seems useless if we don't sync tokens ?
					// var request_admin = user_request.TokenSellRequest_Admin
					// await request_admin.sync({inner:false}) // sync status // inner:false to not auto-sync inner .tokens !

					var oracle_Timestamp = tokenSellRequest_Admin.oracle_Timestamp
					await oracle_Timestamp.sync() // TODO in parallel with Promise.all(...)
					log("(user_request_loc=", user_request_loc, "): synced oracle_Timestamp=", oracle_Timestamp)
				}

				// if we received a bsv payment we melt it to the purse
				if ("paid_BSV_Payment" in tokenSellRequest_Admin) {
					const paid_BSV_Payment = tokenSellRequest_Admin.paid_BSV_Payment
					if (paid_BSV_Payment.satoshis > 0) {
						try {
							await paid_BSV_Payment.sync()
							log("(user_request_loc=", user_request_loc, "): melting paid_BSV_Payment:", paid_BSV_Payment)
							await paid_BSV_Payment.melt()
							await paid_BSV_Payment.sync()
							log("(user_request_loc=", user_request_loc, "): melted paid_BSV_Payment:", paid_BSV_Payment)
							userContext.update_balance_bsv()
							// TODO catch and display error about need for more bsv to melt ? quite paradoxal
						} catch (e) {
							/* we can have errors where we try to melt jigs that are not in their latest state
							because they are not indexed by the node (old test contracts for example)*/
							log("Error trying to melt location", paid_BSV_Payment.location, ":", e)
						}
					}
				}
			}

			// sync all in parallel with Promise.all or .allSettled(...)
			var all_promises = []
			let all_locs = []
			for (let i = 0; i < user_sell_requests.length; i++) {
				var user_request = user_sell_requests[i]

				all_promises.push(
					_sync_TokenSellRequest_Admin_and_subs(user_request)
				)
				all_locs.push(user_request.location)
			}
			log("syncing", all_promises.length, "subcontracts... from locations=", all_locs)
			//allSettled necesary because we get sometime: "Error: X  not found in the transaction"
			// await Promise.all(all_promises) // breaks execution if some reject
			await Promise.allSettled(all_promises) // passes no matter if some reject
			log("finished syncing", all_promises.length, "subcontracts:", all_promises)
			log("synced user_sell_requests=", user_sell_requests)

			// sort user_requests to display latest first
			// TODO we need to sort in front-end instead (or as well) because timestamp from oracle is not guaranteed for sell requests
			user_sell_requests.sort((a, b) => {
				a = a.get_timestamp() || Number.MAX_SAFE_INTEGER
				b = b.get_timestamp() || Number.MAX_SAFE_INTEGER
				if (a < b) return 1
				if (a > b) return -1
				return 0
			})

			// we update if we have new requests
			var need_update = false
			if (user_sell_requests && (!state.user_sell_requests
				|| user_sell_requests.length > state.user_sell_requests.length)
			) {
				need_update = true
			}

			// we must also update if same length but status or timestamp changed
			if (!need_update && user_sell_requests && user_sell_requests.length > 0) {
				if (JSON.stringify(state.user_sell_requests.map(jig => jig.get_status()))
					!== JSON.stringify(user_sell_requests.map(jig => jig.get_status()))) {
					need_update = true
				}
				else if (JSON.stringify(state.user_sell_requests.map(jig => jig.get_timestamp()))
					!== JSON.stringify(user_sell_requests.map(jig => jig.get_timestamp()))) {
					need_update = true
				}
			}

			if (need_update) {
				log("need_update for user_sell_requests")
				set_user_sell_requests(user_sell_requests)
			}

		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (state.user_sell_requests == null) {
				setTimeout(() => { refresh_user_sell_requests(params) }, RETRY_REFRESH_AFTER_MS)
			}
		}
		_release_lock(function_id)
	}

	// TODO use the promise.allSettled() in all _requests functions
	async function refresh_user_buy_requests(params = {}) {
		/*
		 * args: dict with:
		 * 		inventory_sync: boolean, defaults to true
		 */
		var inventory_sync = true  // default
		if (params.hasOwnProperty('inventory_sync')) inventory_sync = params['inventory_sync']
		const function_id = classname + "refresh_user_buy_requests(): "
		const log = (...args) => { console.log(function_id, "(inventory_sync=" + inventory_sync + "): ", ...args) }

		log("_locks[function_id]=", _locks[function_id])
		// only on initial load, wait for inventory to have synced first (otherwise it's too slow)
		const required_array = [run, Runcraft, TokenBuyRequest_User, inventory_synced_atLeastOnce, !_locks[function_id]]
		if (!has_all_required(required_array)) return
		_take_lock(function_id) // DONT RETURN BELOW WITHOUT RELEASING LOCK

		try {
			log("start, inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce)

			if (inventory_sync) {
				await userContext.inventory_sync()
				log("inventory synced")
			}

			await TokenBuyRequest_User.sync()
			log("TokenBuyRequest_User synced at location=", TokenBuyRequest_User.location)
			var user_buy_requests = jigs.filter(jig => jig instanceof TokenBuyRequest_User)

			log("all (", user_buy_requests.length, ") user_buy_requests=", user_buy_requests)

			// important: filter only the requests for the current token contract
			const tokenorigin = userContext.tokenorigin
			// keep only those with token_class
			user_buy_requests = user_buy_requests.filter(jig => !!jig.valid_token_class)
			user_buy_requests = user_buy_requests.filter(
				jig => jig.valid_token_class.origin === tokenorigin
			)
			log("filtered (", user_buy_requests.length, ") user_buy_requests=", user_buy_requests)

			// sync sub oracles

			async function _sync_oracle_buyrequest_and_melt_BSV_Refund(oracle_buyrequest) {
				if (!oracle_buyrequest) return

				await oracle_buyrequest.sync()

				// auto-melt unmelted BSV_Refund if there's one

				var BSV_Refund = null
				if ("BSV_Refund" in oracle_buyrequest) { // refunded by oracle
					BSV_Refund = oracle_buyrequest.BSV_Refund
				}
				else if ("success_TokenBuyRequest_Admin" in oracle_buyrequest) {
					var admin_buyrequest = oracle_buyrequest.success_TokenBuyRequest_Admin
					if (admin_buyrequest && "BSV_Refund" in admin_buyrequest) { // refunded by admin
						BSV_Refund = admin_buyrequest.BSV_Refund
					}
				}

				await _sync_and_melt_BSV_Refund(BSV_Refund)
			}

			// sync all in parallel with Promise.all or .allSettled(...)
			var all_promises = []
			for (let i = 0; i < user_buy_requests.length; i++) {
				var user_request = user_buy_requests[i]

				// by default the oracle_Timestamp & others are not synced
				// and we don't yet have a way to sync only using cache
				// so we are forced to sync, TODO ask Brenton for a way to sync only using cache
				if ("oracle_Timestamp" in user_request && !user_request.oracle_Timestamp.value) {
					all_promises.push(_sync_jig(user_request.oracle_Timestamp))
				}
				if ("oracle_BSVEUR" in user_request && !user_request.oracle_BSVEUR.value) {
					all_promises.push(_sync_jig(user_request.oracle_BSVEUR))
				}
				if ("oracle_TokenBuyRequest_BasePrice" in user_request) {
					all_promises.push(_sync_oracle_buyrequest_and_melt_BSV_Refund(
						user_request.oracle_TokenBuyRequest_BasePrice
					))
				}
			}
			log("syncing", all_promises.length, "subcontracts...", all_promises)
			/* allSettled necesary because we get some of this error:
			Error catched: Error: OracleRequest_USDpriced  not found in the transaction
			*/
			// await Promise.all(all_promises) // breaks execution if some reject
			await Promise.allSettled(all_promises) // passes no matter is some reject
			log("finished syncing", all_promises.length, "subcontracts.")

			// sort user_requests by timestamps to display latest first
			user_buy_requests.sort((a, b) => {
				a = a.get_timestamp() || Number.MAX_SAFE_INTEGER
				b = b.get_timestamp() || Number.MAX_SAFE_INTEGER
				if (a < b) return 1
				if (a > b) return -1
				return 0
			})

			// we update if we have new requests
			var need_update = false
			if (user_buy_requests && (!state.user_buy_requests
				|| user_buy_requests.length > state.user_buy_requests.length)
			) {
				need_update = true
			}

			// we must also update if same length but status changed
			if (!need_update && user_buy_requests && user_buy_requests.length > 0) {
				if (JSON.stringify(state.user_buy_requests.map(jig => jig.get_status()))
					!== JSON.stringify(user_buy_requests.map(jig => jig.get_status()))) {
					need_update = true
				}
				else if (JSON.stringify(state.user_buy_requests.map(jig => jig.get_timestamp()))
					!== JSON.stringify(user_buy_requests.map(jig => jig.get_timestamp()))) {
					need_update = true
				}
				else if (JSON.stringify(state.user_buy_requests.map(jig => jig.oracle_BSVEUR.value))
					!== JSON.stringify(user_buy_requests.map(jig => jig.oracle_BSVEUR.value))) {
					need_update = true
				}
			}

			if (need_update) {
				log("need_update for user_buy_requests")
				set_user_buy_requests(user_buy_requests)
			}
			else {
				log("no need to update user_buy_requests.")
			}
		} catch (e) {
			console.error(function_id + "Error catched:", e)
			if (state.user_buy_requests == null) {
				setTimeout(() => {
					refresh_user_buy_requests(params)
				}, RETRY_REFRESH_AFTER_MS)
			}
		}
		_release_lock(function_id)
	}

	async function reload(params = {}) {
		const function_id = classname + "reload(): "
		let log = getLog(function_id)
		// var inventory_sync = true  // default
		// if(params.hasOwnProperty('inventory_sync')) inventory_sync = params['inventory_sync']

		if (!token_balance_has_loaded || !inventory_synced_atLeastOnce || !hasSet_swapbotAdmin) return

		if (isloading) return  // reload lock already taken
		set_isloading(true)

		log("start")

		// beware you can't set_X(null) here because of the way we use needupdate in below functions
		// it will NOT update the value from null and remain in a never-ending loading state

		refresh_prices()
		refresh_nbAvailableTokens()
		refresh_history_AvailableTokensContract()
		refresh_buy_oracle_priceUSD()
		refresh_sell_oracle_priceUSD()

		// wait for inventory sync once for all calls below
		log("await userContext.inventory_sync()...")
		await userContext.inventory_sync()

		refresh_user_buy_requests({ inventory_sync: false })
		refresh_user_sell_requests({ inventory_sync: false })
		log("isAdminSwapBotOwner=", isAdminSwapBotOwner)
		// specific to admin wallet
		if (isAdminSwapBotOwner) {
			refresh_admin_buy_requests({ inventory_sync: false })
			refresh_admin_sell_requests({ inventory_sync: false })
		}
		log("end (but async calls might end later)")
	}

	function init_state() {
		/* Functions to initialize state (BEWARE INFINITE LOOPS HANDLING)
		* These functions can be quite slow on first load.
		* To deal with that, we should not sync inventory in them on first load,
		* but wait for it to sync in run_context and then only sync on future calls.
		* that's why we introduce the 'params' dict with should_sync arg in it:
				const update_jigs_and_codes = async (params={}) => {
					var inventory_sync = true  // default
					if(params.hasOwnProperty('inventory_sync')) params['inventory_sync']
					if(inventory_sync) await this.inventory_sync()
					...
				}
		*/
		if (init_state_finished) {
			log("init_state(): already finished, aborting.")
			return
		}
		log("init_state(): start. state=", dictFilterFuncs(state))

		let nb_missing_vals = 0

		// prices for tokens being sold
		if (!isNumber(state.base_price) || !isNumber(state.secondary_price)) {
			refresh_prices()
			nb_missing_vals++
		}

		// available tokens at base price
		if (!isNumber(state.nb_available_tokens)) {
			refresh_nbAvailableTokens()
			nb_missing_vals++
		}

		if (!isNumber(state.history_nb_available_tokens)) {
			refresh_history_AvailableTokensContract()
			nb_missing_vals++
		}

		// prices of calling oracles
		if (!isNumber(state.buy_oracle_priceUSD)) {
			refresh_buy_oracle_priceUSD()
			nb_missing_vals++
		}
		if (!isNumber(state.sell_oracle_priceUSD)) {
			refresh_sell_oracle_priceUSD()
			nb_missing_vals++
		}

		// history of what has been bought or sold
		// note: here on first load we don't want to sync inventory here as it's already done in userContext
		if (state.user_buy_requests == null) {
			refresh_user_buy_requests({ inventory_sync: false })
			nb_missing_vals++
		}
		if (state.user_sell_requests == null) {
			refresh_user_sell_requests({ inventory_sync: false })
			nb_missing_vals++
		}

		// specific to admin wallet
		if (isAdminSwapBotOwner) {
			if (state.admin_buy_requests == null) {
				refresh_admin_buy_requests({ inventory_sync: false })
				nb_missing_vals++
			}
			if (state.admin_sell_requests == null) {
				refresh_admin_sell_requests({ inventory_sync: false })
				nb_missing_vals++
			}
		}
		else if (state.admin_buy_requests == null || state.admin_sell_requests == null) {
			set_admin_buy_requests([])
			set_admin_sell_requests([])
		}

		if (nb_missing_vals === 0) {
			set_isloading(false)
			set_init_state_finished(true)
		}
	}

	if (!init_state_finished) {
		if (!isloading) set_isloading(true) // safety check

		if (token_balance_has_loaded && inventory_synced_atLeastOnce && hasSet_swapbotAdmin) {
			log("calling init_state()")
			init_state()
		}
		else {
			// force retry by updating state after delay of 5-10 secs
			log("waiting for token_balance to have loaded before calling init_state()",
				"\n token_balance_has_loaded=", token_balance_has_loaded,
				"\n inventory_synced_atLeastOnce=", inventory_synced_atLeastOnce,
				"\n hasSet_swapbotAdmin=", hasSet_swapbotAdmin,
				"\n balance_token=", balance_token,
				"\n userContext.tokens_balance[tokenID]=", userContext.tokens_balance[tokenID],
				"\n !!run", !!run,  // beware don't log run it contains privkeys !
				"\n !!TokenBuyRequest_Admin=", !!TokenBuyRequest_Admin,
			)
			setTimeout(() => {
				set_refreshCounter(refreshCounter + 1)
			}, 3 * 1000)

			if (run && TokenBuyRequest_Admin && !hasSet_swapbotAdmin) {
				async_set_ownerIsSwapBotAdmin()
			}
		}
	}

	return (
		<SwapBotContext.Provider value={{ ...state }}>
			{props.children}
		</SwapBotContext.Provider>
	)
}

export default SwapBotContext



// // note: usestate() doesn't work with jigs: "cannot call method X of undefined" on set_X(), so we need to use refs
// // example:
// const ref_TokenBuyRequest_Admin = useRef(null)
// const TokenBuyRequest_Admin = ref_TokenBuyRequest_Admin.current
// if(!TokenBuyRequest_Admin && Runcraft && Runcraft.TokenBuyRequest_Admin)
// {
// 	var new_TokenBuyRequest_Admin = Runcraft.TokenBuyRequest_Admin
// 	log("new_TokenBuyRequest_Admin=",new_TokenBuyRequest_Admin)
// 	// beware following line bugs ! jigs in set_X() functions DO NOT WORK: "cannot call method X of undefined"
// 	// if(_TokenBuyRequest_Admin) set_TokenBuyRequest_Admin(_TokenBuyRequest_Admin)
// 	ref_TokenBuyRequest_Admin.current = new_TokenBuyRequest_Admin
// }
